import WebFont from 'webfontloader';

$(document).on("subpage rendered", {}, function(event, uniqueId){
    var $this = $("#" + uniqueId);
   
    WebFont.load({
        google: {
            families: ['Roboto']
        }
    });

    new Swiper(".myNewsSwiper", {
        slidesPerView: 3,
        spaceBetween: 3,
        centeredSlides: false,
        navigation: {
          nextEl: ".news-next",
          prevEl: ".news-prev",
        },
        breakpoints: {
          0: {
            slidesPerView: 1.2,
          },
          768: {
            slidesPerView: 2,
            
          },
          970: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
        },
      });
      
      
});